import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerTeamManagementSetRoleAndPermissionsClick } from "@faire/web-api--source/events/retailerTeamManagement/click/setRoleAndPermissions";
import myTeamPermissions from "@faire/web-api--source/routes/retailer/settings/my-team/permissions/user_token";
import React from "react";
export var InviteUserToast = function(param) {
    var email = param.email, accountToken = param.accountToken;
    return /*#__PURE__*/ _jsxs(Column, {
        align: "baseline",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                truncate: true,
                style: {
                    width: "250px"
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "rG9j8p",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Invite sent to "
                        },
                        {
                            type: 1,
                            value: "userEmailAddress"
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: {
                        userEmailAddress: email
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                tertiaryColor: Core.text.inverse,
                variant: "tertiary",
                linkTo: myTeamPermissions(accountToken),
                onClick: trackRetailerTeamManagementSetRoleAndPermissionsClick,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "AoamHW",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Set role and permissions"
                        }
                    ]
                })
            })
        ]
    });
};
